// extracted by mini-css-extract-plugin
export default {"countdown":"_0-z","srOnly":"a1-z"};